import { DotLottiePlayer } from '@dotlottie/react-player';
import mascotAnimationMonocleSrc from '../assets/mascot-animation-monocle.lottie';
type Props = {
  autoplay?: boolean;
};
export const MascotAnimationMonocle = ({
  autoplay = true
}: Props) => <DotLottiePlayer src={mascotAnimationMonocleSrc} loop autoplay={autoplay} data-sentry-element="DotLottiePlayer" data-sentry-component="MascotAnimationMonocle" data-sentry-source-file="MascotAnimationMonocle.tsx" />;